<template>
  <div
    :class="[
      'relative w-full p-4 md:p-8 scene-card rounded-md cursor-pointer',
      disabeld ? 'disabeld' : ''
    ]"
    @click="handelJump"
  >
    <div class="flex">
      <span class="chapter_index hidden md:block">{{ chapterIndexFormat }}</span>
      <div class="flex flex-col">
        <span class="chapter_title">{{ chapter && chapter.title }}</span>
        <div>
          <div class="content prose max-w-full" v-html="contentHtml"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import showdown from 'showdown';

export type Chapter = {
  title: string;
  description: string;
  path?: string;
};

@Component
export default class SceneCard extends Vue {
  @Prop({ type: Object }) chapter: Chapter;
  @Prop({ type: Number }) chapterIndex: number;
  @Prop({ type: Boolean }) disabeld: boolean;

  get chapterIndexFormat() {
    return String(this.chapterIndex).padStart(2, '0');
  }

  get contentHtml() {
    const converter = new showdown.Converter({
      simpleLineBreaks: true,
      openLinksInNewWindow: true
    });
    return converter.makeHtml(this.chapter.description);
  }

  handelJump() {
    if (this.disabeld) return;
    if (this.chapter.path) return this.sceneCall(this.chapter.path);
    // 兼容老版match写法
    this.handelOldJump();
  }
  sceneCall(path: string) {
    this.$emit('sceneCall', {
      index: this.chapterIndex,
      path
    });
  }

  handelOldJump() {
    window.storyteller.input(this.chapterIndex);
    window.next();
  }
}
</script>
<style scoped>
.scene-card {
  border: 1px solid rgba(151, 151, 151, 0.12);
  box-shadow: 0px 6px 18px 0px rgba(0, 0, 0, 0.02);
}

.disabeld {
  @apply cursor-not-allowed;
}

.scene-card:hover {
  background-color: #f5f7ff;
  border-color: var(--motif-400);
}
.scene-card.disabeld:hover {
  background-color: #fff;
  border: 1px solid rgba(151, 151, 151, 0.12);
}

.scene-card:hover .chapter_index {
  @apply text-motif-500;
}

.scene-card.disabeld:hover .chapter_index {
  color: rgba(144, 120, 210, 0.42);
}

.chapter_index {
  flex: 0 0 1rem;
  @apply text-4xl font-normal text-right mr-4;
  color: rgba(132, 129, 245, 0.43);
}

.chapter_title {
  @apply inline-block text-xl font-medium mt-1 mb-4 tracking-wide;
}

.disabeld .chapter_title {
  @apply text-gray-500;
}

.content {
  color: rgba(102, 102, 102, 1);
}

.content /deep/ a,
.content /deep/ p {
  word-wrap: break-word;
  overflow-wrap: break-word !important;
}

.content /deep/ strong {
  font-weight: bold;
}
</style>
